<div class="modal-body" style="padding: 2rem">
  <div>
    <h4 class="modal-title" id="modal-basic-title" style="display: flex; justify-content: flex-start; font-weight: 700">
      Bosch RideCare End User Terms</h4>
  </div>
  <div style="padding: 1rem 0">
    <p>
      These <a (click)="openEula()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" style="width: 1.5rem;
        height: 1.5rem;
        margin: -5px -3px -3px;">
        <path
          d="M139.941 86H140v54H52V52h54v.059L98.059 60H60v72h72V93.941L139.941 86zM124 36v8h18.343L93.17 93.171l5.658 5.658L148 49.657V68h8V36h-32z"
          style="fill: #007bc0;"/>
      </svg>
      End User Terms</a> constitute a legal agreement
      between the End User and Bosch RideCare.
      By accessing or otherwise using RideCare, the End User agrees to be bound by these End User Terms.
  </div>
  <div style="display: flex; justify-content: flex-end; gap: 1rem" tabindex="-1">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" tabindex="-1">Decline</button>
    <button type="button" class="btn btn-primary" (click)="acceptEula()" tabindex="-1">Accept</button>
  </div>
</div>
